// Official SAT catalogs for Mexican invoicing
// Based on the official Mexican tax authority (SAT) catalogs

export const regimenFiscalCatalog = [
  { codigo: '601', descripcion: 'General de Ley Personas Morales' },
  { codigo: '603', descripcion: 'Personas Morales con Fines no Lucrativos' },
  { codigo: '605', descripcion: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
  { codigo: '606', descripcion: 'Arrendamiento' },
  { codigo: '607', descripcion: 'Régimen de Enajenación o Adquisición de Bienes' },
  { codigo: '608', descripcion: 'Demás ingresos' },
  { codigo: '610', descripcion: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
  { codigo: '611', descripcion: 'Ingresos por Dividendos (socios y accionistas)' },
  { codigo: '612', descripcion: 'Personas Físicas con Actividades Empresariales y Profesionales' },
  { codigo: '614', descripcion: 'Ingresos por intereses' },
  { codigo: '615', descripcion: 'Régimen de los ingresos por obtención de premios' },
  { codigo: '616', descripcion: 'Sin obligaciones fiscales' },
  { codigo: '620', descripcion: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
  { codigo: '621', descripcion: 'Incorporación Fiscal' },
  { codigo: '622', descripcion: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
  { codigo: '623', descripcion: 'Opcional para Grupos de Sociedades' },
  { codigo: '624', descripcion: 'Coordinados' },
  { codigo: '625', descripcion: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
  { codigo: '626', descripcion: 'Régimen Simplificado de Confianza' },
  { codigo: '628', descripcion: 'Hidrocarburos' },
  { codigo: '629', descripcion: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales' },
  { codigo: '630', descripcion: 'Enajenación de acciones en bolsa de valores' }
];

export const usoCfdiCatalog = [
  { codigo: 'G01', descripcion: 'Adquisición de mercancías' },
  { codigo: 'G02', descripcion: 'Devoluciones, descuentos o bonificaciones' },
  { codigo: 'G03', descripcion: 'Gastos en general' },
  { codigo: 'I01', descripcion: 'Construcciones' },
  { codigo: 'I02', descripcion: 'Mobilario y equipo de oficina por inversiones' },
  { codigo: 'I03', descripcion: 'Equipo de transporte' },
  { codigo: 'I04', descripcion: 'Equipo de computo y accesorios' },
  { codigo: 'I05', descripcion: 'Dados, troqueles, moldes, matrices y herramental' },
  { codigo: 'I06', descripcion: 'Comunicaciones telefónicas' },
  { codigo: 'I07', descripcion: 'Comunicaciones satelitales' },
  { codigo: 'I08', descripcion: 'Otra maquinaria y equipo' },
  { codigo: 'D01', descripcion: 'Honorarios médicos, dentales y gastos hospitalarios' },
  { codigo: 'D02', descripcion: 'Gastos médicos por incapacidad o discapacidad' },
  { codigo: 'D03', descripcion: 'Gastos funerales' },
  { codigo: 'D04', descripcion: 'Donativos' },
  { codigo: 'D05', descripcion: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)' },
  { codigo: 'D06', descripcion: 'Aportaciones voluntarias al SAR' },
  { codigo: 'D07', descripcion: 'Primas por seguros de gastos médicos' },
  { codigo: 'D08', descripcion: 'Gastos de transportación escolar obligatoria' },
  { codigo: 'D09', descripcion: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones' },
  { codigo: 'D10', descripcion: 'Pagos por servicios educativos (colegiaturas)' },
  { codigo: 'P01', descripcion: 'Por definir' },
  { codigo: 'S01', descripcion: 'Sin efectos fiscales' },
];

// Helper function to get regimen fiscal by code
export const getRegimenFiscalByCode = (codigo) => {
  return regimenFiscalCatalog.find(item => item.codigo === codigo);
};

// Helper function to get uso CFDI by code
export const getUsoCfdiByCode = (codigo) => {
  return usoCfdiCatalog.find(item => item.codigo === codigo);
};
